module.exports = "/images/mc.svg?7e249f283f58041e3879ca5504df266d";